/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import * as S from './estilos';
import Logo from '../../Images/Logo.jpg';
import ImgFooter1 from '../../Images/ImgFooter1.png';
import ImgFooter2 from '../../Images/ImgFooter2.png';
import ImgFooter3 from '../../Images/ImgFooter3.png';
import ImgFooter4 from '../../Images/ImgFooter4.png';
import IconeInsta from '../../Images/IconeInsta.png';
import IconFace from '../../Images/IconFace.png';
import BtWhats from '../../Images/whatsapp.png';

import useData from '../../Utils/useData';
import Load from '../Load';

function Header(props: any) {
  const history = useHistory();

  const [load, setLoad] = useState(false);
  const [nome, setNome] = useState('');
  const [nomeValida, setNomeValida] = useState(false);
  const [empresa, setEmpresa] = useState('');
  const [empresaValida, setEmpresaValida] = useState(false);
  const [telefone, setTelefone] = useState('');
  const [telefoneValida, setTelefoneValida] = useState(false);
  const [email, setEmail] = useState('');
  const [emailValida, setEmailValida] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const [mensagemValida, setMensagemValida] = useState(false);
  const [whats, setWhats] = useState(false);

  const [menuMobile, setMenuMobile] = useState(false);
  const [orcamento, setOrcamento] = useState(false);

  const [data, setData] = useState<any>([]);

  const loadData = () => {
    useData()
      .getData('/api/whats.php')
      .then((response: any) => {
        setData(response[0].c_whats);
      })
      .catch((err) => {
        console.info(err);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      loadData();
    }, 1000);
  }, []);


  const MandaSpEventos = () => {
    window.open('http://www.gruposaopauloeventos.com.br/', '_blank');
  };  
  
  const MandaVila = () => {
    window.open('http://www.villacountry.com.br/', '_blank');
  };  
  
  const MandaExpo= () => {
    window.open('http://www.expobarrafunda.com.br/', '_blank');
  };  
  
  const MandaUnimed = () => {
    window.open('http://www.espacounimed.com.br/', '_blank');
  };

  const MandaCasa = () => {
    setMenuMobile(false);
    history.push('/#Casa');
  };

  const MandaHome = () => {
    setMenuMobile(false);
    history.push('/#Home');
  };

  const MandaBuffet = () => {
    setMenuMobile(false);
    history.push('/#Buffet');
  };

  const MandaEstacionamento = () => {
    setMenuMobile(false);
    history.push('/#Estacionamento');
  };

  const MandaLocalizacao = () => {
    setMenuMobile(false);
    history.push('/#Localizacao');
  };

  const MandaEventos = () => {
    setMenuMobile(false);
    history.push('/#Eventos');
  };

  const MandaContato = () => {
    setMenuMobile(false);
    history.push('/#Contato');
  };

  useEffect(() => {
    const hash = props.history.location.hash;
    if (hash && document.getElementById(hash.substr(1))) {
      // Check if there is a hash and if an element with that id exists
      document.getElementById(hash.substr(1))?.scrollIntoView({ behavior: 'smooth' });
    }
    // }, []);
  }, [props.history.location.hash]);

  /* useEffect(() => {
    useData()
      .getData('/api/whats.php')
      .then((response: any) => {
        if (response === 0) {
          setWhats(false);
        } else {
          setWhats(true);
        }
      })
      .catch((err) => {
        console.info(err);
      });
    window.scrollTo(0, 0);
  }, []); */

  return (
    <>
      {data == 1 && <a href='https://wa.me/5511916220748' target='_blank' rel='noreferrer' className='BtWhatsapp'></a>}
      <S.FundoTopo>
        <S.ForaTopo>
          <S.LogoTopo src={Logo} />
          <S.ForaMenu>
            <S.TextMenu href='#Home'>Home</S.TextMenu>
            <S.TextMenu href='#Casa'>A Casa</S.TextMenu>
            <S.TextMenu href='#Buffet'>Buffet</S.TextMenu>
            <S.TextMenu href='#Estacionamento'>Estacionamento</S.TextMenu>
            <S.TextMenu href='#Localizacao'>Localização</S.TextMenu>
            {/* <S.TextMenu href='#Eventos'>Eventos Realizados</S.TextMenu> */}
            <S.TextMenu href='#Contato'>Contato</S.TextMenu>
          </S.ForaMenu>

          <S.DirTopo>
            <S.OutTel>
              <a  target='_blank' href='https://wa.me/5511916220748' rel='noreferrer'>
                <S.ImagemIconeInsta1Whats src={BtWhats} />
              </a>
              <S.ItemTelefone>
                <S.TextTel1>11 91622-0748</S.TextTel1>
                <S.TextTel2> Seg à Sex das 9h às 19h</S.TextTel2>
              </S.ItemTelefone>
            </S.OutTel>
            <S.TextOrcamento href='#Contato'>Solicite orçamento</S.TextOrcamento>
            <S.ForaBotaoResp onClick={() => setMenuMobile(true)}>
              <S.RiscoBotaoResp />
              <S.RiscoBotaoResp />
              <S.RiscoBotaoResp />
            </S.ForaBotaoResp>
          </S.DirTopo>
          <S.OutIconsInsta>
            <a
              className='LinkInsta'
              target='_blank'
              rel='noreferrer'
              href='https://www.instagram.com/villacountry/'>
              <S.ImagemIconeInsta src={IconeInsta} />
            </a>
            <a className='LinkInsta' target='_blank' rel='noreferrer' href='https://www.facebook.com/villacountry'>
              <S.ImagemIconeInsta1 src={IconFace} />
            </a>
          </S.OutIconsInsta>
        </S.ForaTopo>
      </S.FundoTopo>

      {menuMobile == true && (
        <S.FundoMenuMobile>
          <S.ForaMenuMobile>
            <S.XMenuMobile onClick={() => setMenuMobile(false)}>X</S.XMenuMobile>
            <S.CimaMenuMobile>
              <S.TextMenuMobile1>Expo barra funda</S.TextMenuMobile1>
            </S.CimaMenuMobile>
            <S.ItensMenuMobile>
              <S.TextMenuMobile onClick={() => MandaHome()}>HOME</S.TextMenuMobile>
              <S.TextMenuMobile onClick={() => MandaCasa()}>A CASA</S.TextMenuMobile>
              <S.TextMenuMobile onClick={() => MandaBuffet()}>BUFFET</S.TextMenuMobile>
              <S.TextMenuMobile onClick={() => MandaEstacionamento()}>ESTACIONAMENTO</S.TextMenuMobile>
              <S.TextMenuMobile onClick={() => MandaLocalizacao()}>LOCALIZAÇÃO</S.TextMenuMobile>
              {/* <S.TextMenuMobile onClick={() => MandaEventos()}>EVENTOS REALIZADOS</S.TextMenuMobile> */}
              <S.TextMenuMobile onClick={() => MandaContato()}>CONTATO</S.TextMenuMobile>
            </S.ItensMenuMobile>
            <S.TelefoneMenuMobile>11 91622-0748</S.TelefoneMenuMobile>
            <S.TelefoneMenuMobile2>Seg à Sex das 9h às 19h</S.TelefoneMenuMobile2>

            <S.ForaBaixoMenuMobile>
              <S.OutIconMobile>
                <a target='_blank' rel='noreferrer' href='https://www.instagram.com/villacountry/'>
                  <S.ImagemIconeInsta2 src={IconeInsta} />
                </a>
                <a target='_blank' rel='noreferrer' href='https://www.facebook.com/villacountry'>
                  <S.ImagemIconeInsta3 src={IconFace} />
                </a>
                <a target='_blank' href='https://wa.me/5511916220748' rel='noreferrer'>
                  <S.ImagemIconeInsta3 src={BtWhats} />
                </a>
              </S.OutIconMobile>
              <S.BotaoSoliciteResp onClick={() => MandaContato()}>SOLICITE ORÇAMENTO</S.BotaoSoliciteResp>
              <S.TextGrupoResp>Grupo São Paulo Eventos</S.TextGrupoResp>
              <S.ForaImagensResp>
          
                <S.ItemImg onClick={() => MandaVila()}>
                  <S.ImgGrupo src={ImgFooter2} />
                </S.ItemImg>
                <S.ItemImg onClick={() => MandaExpo()}>
                  <S.ImgGrupo src={ImgFooter3} />
                </S.ItemImg>
                <S.ItemImg onClick={() => MandaUnimed()}>
                  <S.ImgGrupo src={ImgFooter4} />
                </S.ItemImg>
              </S.ForaImagensResp>
            </S.ForaBaixoMenuMobile>
          </S.ForaMenuMobile>
        </S.FundoMenuMobile>
      )}

      {orcamento === true && (
        <S.FundoSolicite>
          <S.XSolicite onClick={() => setOrcamento(false)}>X</S.XSolicite>
          <S.ForaSolicite>
            <S.TextPopSolicite1>SOLICITE ORÇAMENTO</S.TextPopSolicite1>
            <div className='FormSolicite'>
              <input type='text' className='InputSolicita' placeholder='NOME' />
              <input type='text' className='InputSolicita' placeholder='E-MAIL' />
              <input type='text' className='InputSolicita' placeholder='TELEFONE' />
              <textarea placeholder='MENSAGEM' className='InputSolicita'></textarea>
              <S.BotaoEnviarSolicite>ENVIAR</S.BotaoEnviarSolicite>
            </div>
          </S.ForaSolicite>
        </S.FundoSolicite>
      )}
    </>
  );
}

export default withRouter(Header);
